import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import app from "../utils/firebase";
import { getDatabase, ref, onValue, set } from "firebase/database";
import { onAuthStateChanged, signOut } from "@firebase/auth";
import { auth } from "../utils/firebaseSecondary";
import QuestionsList from "../components/QuestionsList";
import QuizzesList from "../components/QuizzesList";
import TableButton from "../components/TableButton";
import "./AdminPanel.css";
import { VscHome } from "react-icons/vsc";
import { VscChecklist } from "react-icons/vsc";
import { VscFeedback } from "react-icons/vsc";
import { VscGraph } from "react-icons/vsc";
import { VscSignOut } from "react-icons/vsc";
import { VscSettingsGear } from "react-icons/vsc";

const AdminPanel = () => {
  const [userEmail, setUserEmail] = useState("");
  const [questionsList, setQuestionsList] = useState([]);
  const [quizzesList, setQuizzesList] = useState([]);
  const [mainScreen, setMainScreen] = useState("quizzes");

  const navigate = useNavigate();
  const db = getDatabase();

  const getQuestions = () => {
    const questionsRef = ref(db, "questions");

    onValue(questionsRef, (snapshot) => {
      const questionsData = snapshot.val();
      const questionsList = [];

      for (let question in questionsData) {
        questionsList.push({ question: question, ...questionsData[question] });
      }

      setQuestionsList(questionsList);
    });
  };

  const getQuizzes = () => {
    const quizzesRef = ref(db, "quizzes");

    onValue(quizzesRef, (snapshot) => {
      const quizzesData = snapshot.val();
      const quizzesList = [];

      for (let quiz in quizzesData) {
        quizzesList.push({ quiz: quiz, ...quizzesData[quiz] });
      }

      setQuizzesList(quizzesList);
    });
  };

  // useEffect(() => {
  //   getQuestions();
  //   getQuizzes();
  // }, []);

  const [user, setUser] = useState({});
  onAuthStateChanged(auth, (currentUser) => {
    setUser(currentUser);
  });

  const logout = async () => {
    await signOut(auth);
  };

  useEffect(() => {
    if (user == null) {
      navigate("/login");
    } else {
      getQuestions();
      getQuizzes();
      setUserEmail(user.email?.split("@")[0]);
    }
  }, [user]);

  return (
    <div className="admin-panel">
      <div className="header"></div>
      <div className="sidebar">
        <div className="user-name">
          <img
            src="https://media.istockphoto.com/photos/portrait-of-handsome-smiling-young-man-with-crossed-arms-picture-id1200677760?k=20&m=1200677760&s=612x612&w=0&h=JCqytPoHb6bQqU9bq6gsWT2EX1G5chlW5aNK81Kh4Lg="
            className="avatar"
          ></img>
          <div className="name-texts">
            <p style={{ color: "gray", fontSize: "14px" }}>Hello,</p>
            <p style={{ color: "black", fontSize: "16px", fontWeight: "800" }}>
              {/* {userEmail.split("@")[0]} */}
              {userEmail}
            </p>
          </div>
        </div>
        <div className="table-buttons">
          <TableButton
            text="Home"
            active={0}
            // onClick={() => setMainScreen("quizzes")}
            icon={<VscHome color="black" fontSize="25px" />}
          />
          <TableButton
            text="Questions"
            active={mainScreen === "questions"}
            onClick={() => setMainScreen("questions")}
            icon={<VscFeedback color="black" fontSize="25px" />}
          />
          <TableButton
            text="Quizzes"
            active={mainScreen === "quizzes"}
            onClick={() => setMainScreen("quizzes")}
            icon={<VscChecklist color="black" fontSize="25px" />}
          />
          <TableButton
            text="Stats"
            active={0}
            // onClick={() => setMainScreen("quizzes")}
            icon={<VscGraph color="black" fontSize="25px" />}
          />
          <TableButton
            text="Settings"
            active={0}
            // onClick={() => setMainScreen("quizzes")}
            icon={<VscSettingsGear color="black" fontSize="25px" />}
          />
        </div>
        <TableButton
          text="Log out"
          active={0}
          onClick={() => logout()}
          icon={<VscSignOut color="black" fontSize="25px" />}
        />
      </div>
      <div className="main-body">
        <div className="main-body-info">
          <div className="table-title-container">
            <h1 className="table-title">
              {mainScreen === "quizzes" ? "Quizes" : "Questions"}
            </h1>
            {/* <button className="add-quesrion-cta">
              {mainScreen === "quizzes" ? "Add quiz" : "Add question"}
            </button> */}
          </div>
          <div className="admin-panel-table">
            {mainScreen === "quizzes" ? (
              <QuizzesList quizzes={quizzesList} />
            ) : (
              <QuestionsList questions={questionsList} />
            )}
            {/* <div className="questions">
              <QuestionsList questions={questionsList} />
            </div>

            <div className="quizzes">
              <QuizzesList quizzes={quizzesList} />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
